<app-ui-main-menu>
  <mat-card class="indications-page">
    <mat-card-header>
      <mat-card-title>Relatório de Laudos Atrasados</mat-card-title>
    </mat-card-header>

    <div class="export-overlay" *ngIf="isExporting">
      <mat-progress-spinner mode="indeterminate" [diameter]="60"></mat-progress-spinner>
      <span class="export-msg">Gerando CSV, aguarde...</span>
    </div>

    <mat-card-content class="page-content">
      <form [formGroup]="filtersForm" class="filters" (ngSubmit)="applySearch()" novalidate>
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Pesquisar por</mat-label>
          <input matInput formControlName="search"
            placeholder="nome do paciente, e-mail do cliente, nome do profissional" (keyup.enter)="applySearch()" />
        </mat-form-field>

        <div class="searchBtn">
          <button mat-flat-button color="primary" type="submit">
            Pesquisar
          </button>
        </div>

        <div class="searchBtn">
          <button mat-flat-button type="button" [color]="filtersApplied ? 'warn' : 'primary'"
            [ngClass]="{ 'clear-filters': filtersApplied }" (click)="onFiltersClick()">
            {{ filtersApplied ? 'Limpar filtros' : 'Filtros avançados' }}
          </button>
        </div>

        <div class="searchBtn">
          <button mat-flat-button type="button" class="export" (click)="exportCsv()" [disabled]="isExporting"
            matTooltip="O CSV respeita todos os filtros aplicados, tanto os da pesquisa rápida quanto os filtros avançados">
            <ng-container *ngIf="!isExporting">Exportar CSV</ng-container>
            <ng-container *ngIf="isExporting">Gerando...</ng-container>
          </button>
        </div>
      </form>

      <div class="subtitle">
        Filtro aplicado: {{ getEffectiveMinimumDelayHours() }} horas
      </div>

      <app-loading *ngIf="isLoading"></app-loading>

      <ng-container *ngIf="!isLoading">
        <div *ngIf="dataSource.data.length === 0" class="empty">
          <h3>Nenhum conteúdo disponível</h3>
        </div>

        <div *ngIf="dataSource.data.length > 0" class="table-shell">
          <div class="table-scroll" tabindex="0">
            <table mat-table [dataSource]="dataSource" class="wide-table">
              <ng-container matColumnDef="patientId">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Identificador do paciente">ID Paciente</span>
                </th>
                <td mat-cell *matCellDef="let row">{{ row.patientId || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="patientName">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Nome completo do paciente">Paciente</span>
                </th>
                <td mat-cell *matCellDef="let row">{{ row.patientName || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="clientEmail">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="E-mail da conta/escritorio">Email Cliente</span>
                </th>
                <td mat-cell *matCellDef="let row">{{ row.clientEmail || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="professional">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Profissional/Médico(a) responsável">Profissional</span>
                </th>
                <td mat-cell *matCellDef="let row">{{ row.professional || '-' }}</td>
              </ng-container>

              <ng-container matColumnDef="dueDate">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Data prevista para entrega do laudo">Data prevista</span>
                </th>
                <td mat-cell *matCellDef="let row">{{ formatDate(row.dueDate) }}</td>
              </ng-container>

              <ng-container matColumnDef="delayText">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="col-title" matTooltip="Tempo de atraso do laudo">Tempo de Atraso</span>
                </th>
                <td mat-cell *matCellDef="let row">{{ formatDelayText(row.delayText) }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>

          <mat-paginator [length]="totalRows" [pageIndex]="pageIndex" [pageSize]="pageSize"
            [pageSizeOptions]="[10, 25, 50, 100, 500]" (page)="onSearch($event)">
          </mat-paginator>
        </div>
      </ng-container>
    </mat-card-content>
  </mat-card>
</app-ui-main-menu>